import { TranslationSchema } from "../types/translations";
import { languageStringsAdmin } from "./pl/admin";
import { languageStringsCampaign } from "./pl/campaign";
import { languageStringsContact } from "./pl/contact";
import { languageStringsPopups } from "./pl/popup";
import { languageStringsSubscriptions } from "./pl/subscriptions";

export const pl: TranslationSchema = {
  sidePanel: {
    campaign: "Kampania",
    connection: "Połączenia",
    settings: "Ustawienia",
    infinite: "Bez ograniczeń",
  },
  noTariffBanner: {
    title: "Váš účet nemá aktivní žádný tarif",
    description:
      "Bez aktivního tarifu nemůžeme zobrazit notifikace na Vašich stránkách a zvyšovat tak jejich konverzní poměr.",
    button1: "Aktivovat tarif",
    button2: "na prvních 14 dnů zdarma",
  },
  noPixelBanner: {
    title: "Na stronie internetowej nie osadzono skryptu pikselowego.",
    description: "Aby włączyć powiadomienia, osadź skrypt pikselowy",
    button: "Jak osadzić piksel?",
  },
  apiKeysTitle: "Integracja – wyświetlanie opinii zadowolonych klientów",
  zboziApiChangeNotice: "Uwaga: API Zboží.cz zostało zastąpione nowym API Sklik. Jeśli masz integrację z Zboží.cz, musisz zaktualizować klucz API – nowy token odświeżania uzyskasz na sklik.cz w sekcji Ustawienia → Klucze API.",
  addingApiKeys: "Dodawanie kluczy API",
  optionalAddApiKey:
    "Ten krok jest opcjonalny. Możesz dodać klucze API później",
  monthlyCredits: "Punkty miesięczne",
  portableCredits: "Punkty przenośne",
  extraCredits: "Dodatkowe zakupione kredyty",
  help: "Pomoc",
  reportProblem: "Zgłoś błąd",
  saveChanges: "Zapisz zmiany",
  reset: "Reset",
  defaultSettings: "Ustawienia domyślne",
  addKey: "Dodaj klucz",
  login: "Zaloguj się",
  back: "Z powrotem",
  choose: "Wybierz",
  extraCreditsPage: {
    buttonText: "Kup",
    shows: "wyświetlenia",
    navigationButtonText: "Dokup",
    purchaseError:
      "Nie udało się rozpocząć płatności. Spróbuj ponownie później lub skontaktuj się z pomocą techniczną.",
  },
  close: "Zamknij",
  delete: "Usuń",
  verified: "Zweryfikowano",
  yes: "Tak",
  notVerified: "Brak weryfikacji",
  connected: "Połączone",
  active: "Aktywny",
  inactive: "Nieaktywny",
  check: "Sprawdź",
  add: "Dodaj",
  edit: "Modyfikuj",
  save: "Zapisz",
  continue: "Kontynuuj",
  userIsNotLoggedIn: "Użytkownik nie jest zalogowany",
  deleteWebsite: "Usuń witrynę",
  spolehliveRecenze: "Złączony Zaufane",
  logout: "Wyloguj się",
  paymentFailed: {
    title: "Płatność została anulowana",
    description: "Nie można ukończyć płatności.",
    continue: "Spróbuj ponownie",
  },
  paymentRejected: {
    title: "Płatność została odrzucona",
    description: "Płatność nie została przyjęta. Proszę spróbować ponownie.",
    continue: "Kontynuuj",
  },
  notFound: {
    title: "Nie znaleźliśmy żądanej strony",
    back: "Wstecz",
  },
  loggedOut: {
    title: "Zostałeś wylogowany",
    description: "Możesz zamknąć stronę.",
    close: "Zamknij stronę",
  },
  passwordChange: {
    title: "Zmiana hasła",
    setPasswordTitle: "Ustawienie hasła",
    oldPassword: "Aktualne hasło",
    newPassword: "Nowe hasło",
    password: "Hasło",
    confirmPassword: "Potwierdź nowe hasło",
    passwordMismatch: "Hasła nie pasują do siebie",
    passwordSet: "Hasło zostało ustawione, zaloguj się ponownie.",
    passwordSetFailed: "Nie udało się ustawić hasła",
    passwordChanged: "Hasło zostało zmienione, zaloguj się ponownie.",
    passwordChangeFailed: "Nie udało się zmienić hasła",
    errors: {
      passwordsDoNotMatch: "Hasła nie pasują do siebie",
      failedToChange: "Nie udało się zmienić hasła",
    },
    success: "Hasło zostało zmienione, zaloguj się ponownie.",
  },
  onBoarding: {
    title: "Dodaj swoją pierwszą witrynę internetową",
    description:
      "Nie martw się, poprowadzimy Cię krok po kroku. Już niedługo będziesz mógł korzystać ze wszystkich korzyści jakie niesie ze sobą Zweryfikowana witryna.",
    start: "Początek",
    logout: "Wylogowanie",
    errors: {
      websiteNameTaken: "Witryna o tej nazwie jest już zajęta",
      fillAllFields: "Wypełnij wszystkie pola",
      enterApiKey: "Wprowadź klucz API",
      enterCredentials: "Wprowadź nazwę użytkownika i hasło",
    },
    apiKeyModal: {
      added: "Dodano.",
      notVerified: "Nie zweryfikowano",
      zbozi: {
        noAccessToPremise: "Klucz API nie ma dostępu do tego lokalu. Możliwe przyczyny: (1) Klucz należy do innego konta Sklik niż to zarządzające tym lokalem. (2) Lokal nie ma aktywnego pomiaru konwersji na Zboží.cz – jest to wymagane do korzystania z API recenzji. Konfiguracja pomiaru konwersji: zbozi.cz/mereni-konverzi",
        invalidApiKey: "Klucz API jest nieprawidłowy lub wygasł. Wygeneruj nowy klucz w Ustawienia → Klucze API w Sklik.",
        insufficientPermissions: "Klucz API ma niewystarczające uprawnienia. Utwórz nowy klucz w Sklik z uprawnieniami do danych Zboží.cz / Nákupy.",
        verificationFailed: "Weryfikacja nie powiodła się. Sprawdź klucz API i ID lokalu.",
      },
    },
  },
  resetPassword: {
    title: "Zresetuj hasło",
    reset: "Resetowanie",
    emailSent: "Jeśli istnieje konto z tym adresem e-mail, otrzymasz instrukcje resetowania hasła.",
    newPassword: "Nowe hasło",
    confirmPassword: "Potwierdź hasło",
    submit: "Zresetuj hasło",
    backToLogin: "Powrót do logowania",
    success: "Hasło pomyślnie zresetowane",
    successMessage: "Twoje hasło zostało zresetowane. Wszystkie sesje zostały wylogowane. Możesz się teraz zalogować nowym hasłem.",
    invalidLink: "Nieprawidłowy link",
    errorTitle: "Nieprawidłowy link resetowania",
    errorMessage: "Ten link jest nieprawidłowy lub wygasł. Poproś o nowy link resetowania hasła.",
    passwordTooShort: "Hasło musi mieć co najmniej 8 znaków",
    passwordsMismatch: "Hasła nie są zgodne",
    genericError: "Nie udało się zresetować hasła. Proszę spróbować ponownie.",
    description: "Wprowadź swoje nowe hasło",
    redirecting: "Przekierowanie do logowania",
  },
  deleteWeb: {
    title: "Usuń witrynę?",
    description: "Wszystkie dane i kampanie zostaną usunięte.",
    delete: "Usuń",
    close: "Zamknij",
  },
  loginScreen: {
    title: "Zaloguj sie",
    email: "E-mail",
    password: "Hasło",
    button: "Zaloguj się",
    newUsers: "Nowy użytkownik?",
    forgotPassword: "Zapomniałeś hasła?",
    resetPassword: "Resetowanie",
    signUp: "Zarejestruj się",
  },
  registrationScreen: {
    title: {
      first: "Tylko krok dzieli Cię od",
      second: "zwiększenia współczynnika konwersji",
      third: "Twojego e-sklepu",
      fourth: "nawet o 20%!",
    },
    subTitle:
      "Wypełnij poniższe informacje i dołącz do grona e-zakupów, które odniosły sukces",
    name: "Imię",
    phone: "Numer telefonu (opcjonalnie)",
    email: "Email",
    password: "Hasło",
    confirmPassword: "Potwierdź hasło",
    accept: "Zgadzam się z",
    terms: "warunkami",
    button: "Zakończ rejestrację",
    alreadyHaveAccount: "Czy masz konto?",
    login: "Zaloguj się",
  },
  addWebsite: {
    title: "Dodaj witrynę internetową",
    name: "Nazwa strony",
    warning: "Wpisz pełny adres URL swojej witryny, łącznie z https.",
    includeHttps: "łącznie z https",
    url: "Adres URL witryny",
    notificationLanguage: "Język powiadomień",
    czech: "Čeština",
    slovak: "Slovenština",
    polish: "Polština",
  },
  howToInstallPixel: {
    title: "Jak zainstalować piksel",
    first: "Skopiuj kod Pixela.",
    second:
      "Wklej kod w nagłówku swojej witryny na swojej stronie przed </head>.",
    third:
      "Odwiedź swoją stronę, aby aktywować kod pixel. Następnie sprawdź za pomocą przycisku „Sprawdź”.",
    help: "Jak wstawić kod pixel na stronę internetową?",
  },
  websites: {
    title: "Pokaż wszystko",
    website: "Witrynę",
    created: "Utworzony",
    campaigns: "Kampanie",
    addWebsite: "Dodaj witrynę",
    connect: "Łączyć",
    connected: "Połączony z",
    yourWebsites: "Twoje witrynę internetowe",
    addButton: "Dodaj",
    backButton: "Wstecz",
  },
  iconSelect: {
    selectedIcon: "Wybrana ikona",
    selectIcon: "Kliknij, aby wybrać ikonę",
    dialogTitle: "Wybierz ikonę",
    dialogClose: "Zamknij",
  },
  settingsTabs: {
    webSettings: "Ustawienia podstawowe",
    customLogo: "Własne logo",
  },
  customLogo: {
    showLogo: "Wyświetl logo",
    logo: "Logo",
    text: "Tekst",
    textColor: "Kolor tekstu",
    save: "Zapisz",
  },
  shoptetFirstTouchScreen: {
    title: "Instalacja wtyczki przebiegła pomyślnie.",
    description1:
      "Przygotowaliśmy dla Twojego sklepu internetowego zestaw inteligentnych notyfikacji, które według naszych doświadczeń z podobnymi sklepami internetowymi najefektywniej zwiększą liczbę zamówień w Twoim sklepie internetowym. Uruchomią się one automatycznie. Natychmiast po aktywacji Twojej darmowej jazdy testowej.",
    description2:
      "Kliknij przycisk. Aktywuj inteligentne notyfikacje i obserwuj, jak codziennie wzrasta liczba zamówień.",
    button: "Uruchom testowe 14 dni gratis",
    error: "Logowanie nie powiodło się. Wyloguj się i spróbuj ponownie.",
  },
  upgatesFirstTouchScreen: {
    title: "Wtyczka została pomyślnie zainstalowana.",
    description1:
      "Przygotowaliśmy dla Twojego sklepu internetowego zestaw inteligentnych powiadomień, które na podstawie naszych doświadczeń z podobnymi sklepami najskuteczniej zwiększą liczbę Twoich zamówień. Uruchomią się automatycznie zaraz po aktywacji Twojego bezpłatnego okresu próbnego.",
    description2:
      "Kliknij przycisk, aby aktywować inteligentne powiadomienia i po prostu obserwuj, jak rośnie Twoja dzienna liczba zamówień.",
    button: "Rozpocznij 14-dniowy bezpłatny okres próbny",
    error:
      "Logowanie nie powiodło się. Proszę się wylogować i spróbować ponownie.",
  },
  webarealFirstTouchScreen: {
    title: "Instalacja wtyczki zakończona pomyślnie.",
    description1:
      "Przygotowaliśmy dla Twojego sklepu internetowego zestaw inteligentnych powiadomień, które według naszych doświadczeń z podobnymi sklepami internetowymi najskuteczniej zwiększają liczbę zamówień w Twoim sklepie. Uruchomią się automatycznie. Natychmiast po aktywacji Twojego bezpłatnego okresu próbnego.",
    description2:
      "Kliknij przycisk. Aktywuj inteligentne powiadomienia i obserwuj, jak każdego dnia rośnie liczba zamówień.",
    button: "Uruchom 14-dniowy test za darmo",
    error: "Logowanie nie powiodło się, wyloguj się i spróbuj ponownie.",
  },
  eshopRychleFirstTouchScreen: {
    title: "Witamy w Zweryfikowana Strona!",
    description1: "Twoje konto zostało pomyślnie utworzone.",
    description2: "Proszę ustawić hasło, aby uzyskać dostęp do administracji.",
    button: "Ustaw hasło",
    error: "Logowanie nie powiodło się. Proszę spróbować ponownie.",
  },
  shopifyFirstTouchScreen: {
    title: "Instalacja aplikacji zakończona sukcesem!",
    description1:
      "Przygotowaliśmy dla Twojego sklepu Shopify zestaw inteligentnych powiadomień, które na podstawie naszych doświadczeń z podobnymi sklepami najskuteczniej zwiększą liczbę Twoich zamówień. Uruchomią się automatycznie zaraz po aktywacji Twojego bezpłatnego okresu próbnego.",
    description2:
      "Kliknij przycisk, aby aktywować inteligentne powiadomienia i obserwuj, jak każdego dnia rośnie liczba zamówień.",
    button: "Rozpocznij 14-dniowy bezpłatny okres próbny",
    error: "Logowanie nie powiodło się. Proszę spróbować ponownie.",
  },
  trustPilot: {
    businessUnitId: "ID jednostki biznesowej",
    apiKey: "Klucz API",
    apiSecret: "Sekret API",
    reviews: "recenzji",
    reviewsWithRating: "Recenzje z oceną powyżej",
    stars: "gwiazdek",
    maxReviews: "Minimalna liczba recenzji do wyświetlenia",
    verificationPrompt:
      "Proszę zweryfikować swój klucz API TrustPilot i ID jednostki biznesowej",
    sourceUrlAddress: "ID źródła",
  },
  errors: {
    pixelCheckFailed: "Automatyczne sprawdzenie piksela nie powiodło się.",
    placesApiError: "Wystąpił błąd podczas ładowania danych z Google Maps. Skontaktuj się z nami w celu uzyskania pomocy.",
    userNotFound: "Użytkownik z tym adresem e-mail nie istnieje",
    userAlreadyExists: "Użytkownik z tym adresem e-mail już istnieje",
    fillAllFields: "Proszę wypełnić wszystkie wymagane pola",
    passwordsDoNotMatch: "Hasła nie są zgodne",
    termsRequired: "Wymagana jest zgoda na warunki",
    invalidEmail: "Proszę podać prawidłowy adres e-mail",
    logoFileTooLarge: "Logo jest za duże. Maksymalny rozmiar to {{maxSize}} KB, Twój plik ma {{actualSize}} KB.",
    logoFileTooLargeSimple: "Logo jest za duże. Maksymalny rozmiar pliku to 100 KB.",
    failedToLoadSettings: "Nie udało się załadować ustawień",
    // Backend error types
    Generic: "Wystąpił nieoczekiwany błąd",
    Unauthorized: "Nie masz uprawnień do wykonania tej akcji",
    Unhandled: "Nieobsługiwany błąd",
    NotEnoughCredits: "Nie masz wystarczającej liczby kredytów",
    IntegrityHashNotFound: "Sesja wygasła, zaloguj się ponownie",
    ErrorVerifyingAccessToken: "Błąd weryfikacji tokenu dostępu",
    MissingAccessToken: "Brak tokenu dostępu",
    AccessTokenExpired: "Token dostępu wygasł",
    InvalidCredentials: "Nieprawidłowe dane logowania",
    UserEmailAlreadyExists: "Użytkownik z tym adresem e-mail już istnieje",
    EmailNotSent: "Nie udało się wysłać e-maila, spróbuj ponownie później",
    ItemNotFound: "Element nie został znaleziony",
    WebsiteNotFound: "Strona internetowa nie została znaleziona",
    UserNotFound: "Użytkownik nie został znaleziony",
    CampaignNotFound: "Kampania nie została znaleziona",
    NotificationSettingsNotFound: "Ustawienia powiadomień nie zostały znalezione",
    ParameterBadFormat: "Nieprawidłowy format parametru",
    QueryStringMissing: "Brak parametru URL",
    BodyParameterMissing: "Brak parametru żądania",
    EnvVarNotFound: "Brak zmiennej konfiguracyjnej",
    PricingPlanNotFoundInStripe: "Plan cenowy nie został znaleziony w Stripe",
    PricingPlanInconsistencyInStripe: "Niespójność planu cenowego w Stripe",
    PriceNotFoundInStripe: "Cena nie została znaleziona w Stripe",
    CustomerNotFoundInStripe: "Klient nie został znaleziony w Stripe",
    SubscriptionInconsistencyInStripe: "Niespójność subskrypcji w Stripe",
    SubscriptionNotFoundInStripe: "Subskrypcja nie została znaleziona w Stripe",
    PricingPlanCreditsNotFound: "Kredyty planu cenowego nie są skonfigurowane",
    StripeWebhookError: "Błąd webhooka Stripe",
    CustomerDeletedInStripe: "Klient został usunięty w Stripe",
    UnexpectedStripeInvoicePayload: "Nieoczekiwane dane od Stripe",
    StripeSessionUrlError: "Błąd URL sesji płatności Stripe",
    ThirdPartyApiError: "Błąd zewnętrznego API",
    UserWithoutPasswordError: "Użytkownik nie ma ustawionego hasła, prawdopodobnie zarejestrował się przez system zewnętrzny",
    PrivateKeyDoesNotMatch: "Klucz prywatny nie pasuje",
    UserNotDeletedInStripe: "Użytkownik nie został usunięty ze Stripe",
    InvalidRequestBody: "Nieprawidłowy format żądania",
    UserNotRegisteredThroughWebareal: "Użytkownik nie został zarejestrowany przez Webareal",
    WebarealWebsiteAlreadyExists: "Ten sklep Webareal jest już zarejestrowany",
    UserNotRegisteredThroughUpgates: "Użytkownik nie został zarejestrowany przez Upgates",
    RedisClientNotFound: "Klient Redis nie został znaleziony",
    PayloadTooLarge: "Żądanie jest zbyt duże",
  },
  cancelSubscription: {
    title: "Czy na pewno chcesz anulować odnowienie subskrypcji?",
    confirmButton: "Tak, anuluj",
    cancelButton: "Wróć",
  },
  admin: languageStringsAdmin,
  campaign: languageStringsCampaign,
  subscriptions: languageStringsSubscriptions,
  contact: languageStringsContact,
  popups: languageStringsPopups,
};
